import { apiClient, handleApiSuccess } from './api';

/**
 * OTP Service
 * Handles OTP-related API calls for email verification and password reset
 */
export class OTPService {
  /**
   * Send verification OTP to email
   * Can be used for new registrations or existing users
   */
  static async sendVerificationOTP(email: string): Promise<{ message: string }> {
    const response = await apiClient.post('/auth/send-verification-otp', { email });
    return handleApiSuccess(response);
  }

  /**
   * Verify email with OTP code
   */
  static async verifyEmailOTP(email: string, otp: string): Promise<{ message: string; emailVerified: boolean }> {
    const response = await apiClient.post('/auth/verify-email-otp', { email, otp });
    return handleApiSuccess(response);
  }

  /**
   * Send password reset OTP
   */
  static async sendPasswordResetOTP(email: string): Promise<{ message: string }> {
    const response = await apiClient.post('/auth/send-reset-otp', { email });
    return handleApiSuccess(response);
  }

  /**
   * Verify password reset OTP
   */
  static async verifyPasswordResetOTP(email: string, otp: string): Promise<{ message: string; resetToken: string }> {
    const response = await apiClient.post('/auth/verify-reset-otp', { email, otp });
    return handleApiSuccess(response);
  }
}

export default OTPService;
